import { createContext, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "app/components";
import { ErrorMessage } from "app/components/error-message";
import { empresasService } from "app/services";

const CorreoElectronicoContext = createContext();

const initialState = {
  correo_electronico_direccion: "",
  correo_electronico_principal: false,
};

export function CorreoElectronicoProvider({ children }) {
  const params = useParams();

  const [correoElectronico, setCorreoElectronico] = useState(initialState);
  const [isEditing, setEditing] = useState(false);

  const correoElectronicoQuery = useQuery({
    queryKey: [
      "empresa:get:correo-electronico",
      params.empresa_id,
      params.correo_electronico_id,
    ],
    queryFn: () =>
      empresasService.getCorreoElectronico({
        empresaId: params.empresa_id,
        correoElectronicoId: params.correo_electronico_id,
      }),
    onSuccess: (data) => {
      setCorreoElectronico(data);

      setEditing(true);
    },
    enabled: !!params.correo_electronico_id,
  });

  if (!!correoElectronicoQuery.isLoading && !!params.correo_electronico_id) {
    return <Spinner label="Cargando la dirección de correo electrónico..." />;
  } else if (
    !!correoElectronicoQuery.isFetching &&
    !!params.correo_electronico_id
  ) {
    return (
      <Spinner label="Recuperando la dirección de correo electrónico..." />
    );
  } else if (
    !!correoElectronicoQuery.isRefetching &&
    !!params.correo_electronico_id
  ) {
    return <Spinner label="Recargando la dirección de correo electrónico..." />;
  } else if (!!correoElectronicoQuery.isError) {
    return (
      <ErrorMessage
        message={correoElectronicoQuery.error.response.statusText}
      />
    );
  }

  return (
    <CorreoElectronicoContext.Provider
      value={{
        correoElectronico,
        setCorreoElectronico,
        isEditing,
      }}
    >
      {children}
    </CorreoElectronicoContext.Provider>
  );
}

export function useCorreoElectronicoContext() {
  const correo_electronicoContext = useContext(CorreoElectronicoContext);

  if (!correo_electronicoContext) {
    throw new Error(
      "useCorreoElectronicoContext should be used inside the CorreoElectronicoProvider."
    );
  }

  return correo_electronicoContext;
}
